var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"draggable",rawName:"v-draggable"}],staticClass:"ai-box",on:{"click":_vm.handleToggle}},[_c('img',{attrs:{"src":require("./../../assets/img/message.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }